import { List } from '@fourthwall/components';
import React from 'react';
import { ConnectedSiteListItem } from '../ConnectedSitesListItem/ConnectedSitesListItem';
export const ConnectedSitesList = ({ items }) => (React.createElement(List, { data: items, topBorder: false, renderItem: (connectedSite) => (React.createElement(ConnectedSiteListItem, { connectedSite: connectedSite })) }));
